
        <div class="content-box">
            <div class="search-text-box">
                <app-mini-env-heading-block [miniTitle]="'Search your Medication'"
                    [title]="'Click to Search Your Medications'"
                    [description]="'We have all major medications available either free or at dicounted prices. Search for yours below!'"
                    [leftAlign]="true"></app-mini-env-heading-block>
                <app-search-input [zipCodePlaceholder]="'19064'"
                    [keywordplaceholder]="('SEARCH.INPUT.PLACEHOLDER' | translateIt: {language: sharedService.currentLanguage} | async)"
                    [noData]="noData" (searchAction)=" sharedService.routeToSearch()"
                    (searchChange)="getMedicines($event)" [isLoading]="isLoading" [showSearchIconLeft]='false'
                    [showSearchText]="false" [backgroundColor]="'white'" [locationIcon]="'icons/location-aca.svg'">
                    <div *ngIf="sharedService.results.length != 0" class="results">
                        @for (item of sharedService.results; track $index) {
                        <div class="listing-item" (click)="sharedService.selectPharmacy(item)">
                            <div class="content">
                                <p class="text">{{item.drugName}}</p>
                                @if(item.drugType == "Acute" || item.drugType == "Formulary" || item.drugType ==
                                "AcuteFormulary"){
                                <p class="free">Free</p>
                                }
                            </div>
                        </div>
                        }
                    </div>
                </app-search-input>
                <p class="search-description"> Quick search for popular medications:<span> Aspirin, Ibuprofen,
                        Amoxicillin</span></p>

            </div>
            <div class="image-container">
                <img class="man-reading-image" [src]="imgSrc" />
            </div>
        </div>